
import { defineComponent } from 'vue';
import { useStore } from 'vuex';
import InfoNav from '../../../components/Info/InfoNav.vue';

export default defineComponent({
  name: 'Info',
  components: { InfoNav },
  setup() {
    const store = useStore();
    const toHome = () => {
      store.commit('changeActiveHead', 'main');
    };
    return {
      toHome,
    };
  },
});
